// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-page{background-position:100% 100%}@media (max-width:640px){.error-page{background-image:url(https://a.storyblok.com/f/99717/800x1180/8caec74963/404_header_background_mobile.jpg);background-size:cover;height:780px;align-items:flex-start;padding-top:175px}}@media (min-width:641px){.error-page{background-image:url(https://a.storyblok.com/f/99717/2160x1180/52aaab221c/404_header_background.jpg)}}", ""]);
// Exports
module.exports = exports;
